"use client"

import useSWR from "swr"

import { fetchPopularGames } from "@/client-api/casino/popular"
import type { LobbySuggestion } from "@/domain/casino/listing/types"

type PopularGamesState = {
  games: LobbySuggestion[]
  isLoading: boolean
  isError: boolean
}

export function usePopularGames(): PopularGamesState {
  const { data, error, isLoading } = useSWR(
    ["casino/popular-games"],
    () => fetchPopularGames(),
    { revalidateOnFocus: false }
  )

  const pending = data === undefined && !error

  return {
    games: data?.games ?? [],
    isLoading: isLoading || pending,
    isError: Boolean(error)
  }
}
